import { PublicationListType } from "generated/CoreApi_v1";
import { ListSystemViewer } from "views/knowledge/publication/pages/List/ListSystemViewer";

export const FeedFavorite: React.FC = () => {
    return <ListSystemViewer listType={PublicationListType.Favorite} />;
}

